import { apiService } from "../axiosService";

/* -------------------------------------------------------------------------- */
/*                       AZURE KEY VAULT (platform-level)                     */
/* -------------------------------------------------------------------------- */
// Platform-level env secrets stored in Azure Key Vault. The backend scopes the
// list to the configured APP_SECRET_PREFIX and presents underscore-form env
// keys (e.g. DATABASE_URL). These endpoints are not app-scoped, so no
// Zino-App-Id header is sent.
//
// Azure has no server-side secret filtering, so listing pages the whole vault
// and can take far longer than the global 20s axios timeout. Every call here
// overrides it to 60s. The list call additionally REQUIRES a search term (the
// backend rejects an empty one) so the vault is never enumerated unsolicited.

const KEYVAULT_TIMEOUT = 60000;
// Writes (Push) get a larger ceiling than reads/search.
const KEYVAULT_WRITE_TIMEOUT = 120000;

// Search the env secret keys (no values). `search` is required by the backend.
export const getKeyVaultSecretsApi = async ({ search, signal } = {}) => {
  const response = await apiService.get(`/keyvault/secrets`, {
    params: { search },
    signal,
    timeout: KEYVAULT_TIMEOUT
  });
  return response;
};

// Reveal the value of a single env secret by its key.
export const getKeyVaultSecretApi = async ({ key, signal } = {}) => {
  const response = await apiService.get(`/keyvault/secrets/${encodeURIComponent(key)}`, {
    signal,
    timeout: KEYVAULT_TIMEOUT
  });
  return response;
};

// Update the value of a single env secret by its key.
export const updateKeyVaultSecretApi = async ({ key, value }) => {
  const response = await apiService.put(
    `/keyvault/secrets/${encodeURIComponent(key)}`,
    { value },
    { timeout: KEYVAULT_WRITE_TIMEOUT }
  );
  return response;
};

// Paginated change history (who/when/IP + old→new version references, no values).
export const getKeyVaultAuditLogsApi = async ({ page = 1, limit = 20, search = "", signal } = {}) => {
  const response = await apiService.get(`/keyvault/audit-logs`, {
    params: { page, limit, ...(search ? { search } : {}) },
    signal,
    timeout: KEYVAULT_TIMEOUT
  });
  return response;
};
